<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <b-row v-if="contenidoTabla.datosTabla !== null"> 
            <b-col cols="12">
                <div class="subtitulos-interno">
                    <b-row>
                        <b-col class="seccionTituloSubTitulo">
                            <span>{{contenidoTabla.label}}</span>
                        </b-col>
                    </b-row>
                </div>

                <b-table thead-tr-class="columnas" :items="contenidoTabla.datosTabla" :fields="contenidoTabla.titulos" 
                :per-page="registrosPorPagina" 
                :current-page="paginaActual" responsive>
                    <template #cell()="valores">     
                        <div :is="valores.field.component" :data="valores" v-if="valores.field.component !== undefined"></div>
                        <span v-else>{{ valores.value }}</span>
                    </template>
                </b-table>
                <b-pagination v-if="contenidoTabla.datosTabla !== undefined && contenidoTabla.datosTabla.length > 10" 
                align="center" v-model="paginaActual" :total-rows="contenidoTabla.datosTabla.length" 
                :per-page="registrosPorPagina" aria-controls="my-table1"></b-pagination>

            </b-col>
        </b-row> 
</div>
</template>

<script>
export default {
    name: "TablaComponente",
    components: {},
    props: { 
        contenidoTabla : Object, 
    },
    data: () => ({
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
        paginaActual: 1,
        registrosPorPagina: 10,
    }),
    watch: {},
    computed: {},
    created() {
      this.debug = this.$localStorageService.getDebug();
    },
    mounted() {},
    methods: {

    },

}
</script>
